import React, {Component} from 'react';
import Loader from '../Components/Loader';
import AuthService from "../services/auth.service";
import ReactLoading from 'react-loading';
import axios from 'axios';
import { Modal,ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
class   Login extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            username: "",
            password: "",
            loading: false,
            message: "",
            action:'/index',
            modal: false
          };
    }


    restPassword(){
        const USR_TOKEN = localStorage.getItem("userToken")
        const resetData= {
            new_password: this.userPassword
        }
        axios.put(process.env.REACT_APP_API_URL + 'api/resource/User/rajeesh4mm@gmail.com',resetData,{
            headers : {'Authorization' : USR_TOKEN, 
            'content-type': 'application/json'}
        })                
        .then(response=>{
            //this.setState({userlogin:response.data})
            console.log(response.data)
        })
            .catch(
                err =>{ console.log(err)}
        )

    }
    async componentDidMount(){
       
        AuthService.getCurrentUser();
            const user = AuthService.getCurrentUser();
        //this.setState({ redirect: "/index.html" });
        if(user){
           
          // window.location.href = "/portal";
        }
       
    
    }

    handleLoginSubmit = e => {
        
        const delay = ms => new Promise(res => setTimeout(res, ms));
        e.preventDefault();
           /* const loginData= {
                usr:this.userName,
                pwd:this.userPassword
            }

        axios.post(process.env.REACT_APP_API_URL + 'api/method/login', loginData,{
            headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
            'content-type': 'application/json'}
        })                
        .then(response=>{
            this.setState({userlogin:response.data})
            console.log(response.data)
        })
            .catch(
                err =>{ console.log(err)}
        )*/
        
        AuthService.login(this.userName, this.userPassword)
        .then(
            async  () => {
              const { history } = this.props;
              
              //await delay(2000);
             // this.props.history.push('/index.html') 
             //window.location.reload();
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
    
              this.setState({
                loading: false,
                message: resMessage
              });
            }
          )
          .catch(err=>{
            this.setState({
                loading: false,
              });
            }) 
            this.setState({
                loading: true,
              });   
    }
    modalOpen() { 
        this.setState({ modal: true });
      }
  render() {
return   <div className="nk-content ">
<div className="container wide-sm">
    <div className="nk-content-inner">
        <div className="nk-content-body">
            <div className="nk-content-wrap">
                <div className="nk-block-head nk-block-head-lg wide-sm m-auto text-center">
                   {/*  <div className="nk-block-head-sub"><a href="support.html" className="text-soft"><span>Contact</span></a></div> */}
                    <div className="nk-block-head-content">
                        <h2 className="nk-block-title fw-normal">Login</h2>
                        {/* <div className="nk-block-des">
                            <p>You can find all of the questions and answers abour secure your account</p>
                        </div> */}
                    </div>
                </div>
                {/* <!-- .nk-block-head --> */}
                <div className="nk-block mb-3">
                    <div className="card card-bordered">
                        <div className="card-inner">
                            <form action="#" className="form-contact" >
                                <div className="row g-4">
                                   {/*  <div className="col-md-6">
                                        <div className="custom-control custom-radio">
                                            <input type="radio" className="custom-control-input" name="type" id="type-general" checked/>
                                            <label className="custom-control-label" for="type-general">A general enquiry</label>
                                        </div>
                                    </div> */}
                                   {/*  <!-- .col --> */}
                                    {/* <div className="col-md-6">
                                        <div className="custom-control custom-radio">
                                    import ReactLoading from 'react-loading';
        <input type="checkbox" className="custom-control-input" name="type" id="type-problem"/>
                                            <label className="custom-control-label" for="type-problem">I have a problem need help</label>
                                        </div>
                                    </div> */}
                                    {/* <!-- .col --> */}
                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label"><span>Category</span></label>
                                            <div className="form-control-wrap">
                                                <select className="form-select" data-search="off" data-ui="lg">
                                                    <option value="general">General</option>
                                                    <option value="billing">Billing</option>
                                                    <option value="technical">Technical</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div> */}
                                   {/*  <!-- .col --> */}
                                   {/*  <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label"><span>Priority</span></label>
                                            <div className="form-control-wrap">
                                                <select className="form-select" data-search="off" data-ui="lg">
                                                    <option value="normal">Normal</option>
                                                    <option value="important">Important</option>
                                                    <option value="high">High Piority</option>
                                                </select>
                                            </div>
                                        </div>
                                    import ReactLoading from 'react-loading';
</div> */} 
                                   {/*  <!-- .col --> */}
                                    <div className="col-12">
                                        {/*<Loader/>*/}
                                        <div className="form-group">
                                    
                                            <label className="form-label">Email</label>
                                            <div className="form-control-wrap">
                                                <input type="email" className="form-control form-control-lg" placeholder="Enter your Email "
                                                onChange={e => this.userName = e.target.value}/>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Password</label>
                                            <div className="form-control-wrap">
                                                <input type="password" className="form-control form-control-lg" placeholder="Enter your Password "
                                                onChange={e => this.userPassword = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="col-md-12">
                                        <div className="custom-control custom-radio">
                                            <input type="checkbox" className="custom-control-input" name="type" id="type-problem"/>
                                            <label className="custom-control-label" for="type-problem">Stay Logged In</label>
                                        </div>
                                    </div>*/}
                                   {/*  <!-- .col --> */}
                                   {/*  <div className="col-12">
                                        <div className="form-group">
                                            <label className="form-label"><span>Give us the details </span><em className="icon ni ni-info text-gray"></em></label>
                                            <p className="text-soft">If you’re experiencing a personal crisis, are unable to cope and need support send message. We will always try to respond to texters as quickly as possible.</p>
                                            <div className="form-control-wrap">
                                                <div className="form-editor-custom">
                                                    <textarea className="form-control form-control-lg no-resize" placeholder="Write your message"></textarea>
                                                    <div className="form-editor-action">
                                                        <a className="link collapsed" data-toggle="collapse" href="#filedown"><em className="icon ni ni-clip"></em> Attach file</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                   {/*  <!-- .col --> */}
                                   {/*  <div className="col-12">
                                        <div className="choose-file">
                                            <div className="form-group collapse" id="filedown">
                                                <div className="support-upload-box">
                                                    <div className="upload-zone">
                                                        <div className="dz-message" data-dz-message>
                                                            <em className="icon ni ni-clip"></em>
                                                            <span className="dz-message-text">Drag your file</span>
                                                            <span className="dz-message-or"> or</span>
                                                            <button className="btn btn-primary">Select</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */} 
                                   {/*  <!-- .col --> */}
                                    <div className="col-12">
                                        {this.state.loading ?
                                        <p className=" loader-color " >Loging <ReactLoading type="spin" color="#d0141b" height={50} width={25} className="ml-1"/></p>
                                        :<a href="#0" className="btn btn-primary" type="button" onClick={this.handleLoginSubmit} >Log in</a>}
                                    </div>
                                   {/*  <!-- .col --> */}
                                </div>
                              {/*   <!-- .row --> */}
                            </form>


                          {/*   <!-- .form-contact --> */}
                        </div>
                        {/* <!-- .card-inner --> */}
                    </div>
                  {/*   <!-- .card --> */}
                </div> 
               {/*  <!-- .nk-block --> */}
            </div>
        </div>
    </div>
</div>
</div>
  

}
}
export default Login;